import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import VerificaToken from "../../components/VerificaToken";
import { useHistory, useParams, Link, Redirect } from "react-router-dom";

import Zoom from "react-reveal/Zoom";
import { Container, Col, Row, Button } from "react-bootstrap";
import Bounce from "react-reveal/Bounce";

import axios from "axios";

function GetHourDiff(pStartHour, pEndHour) {
  var res = "";
  var aTmp = "";
  aTmp = pStartHour.split(":");
  var nStartMin = Number(aTmp[0]) * 60 + Number(aTmp[1]);
  aTmp = pEndHour.split(":");
  var nEndMin = Number(aTmp[0]) * 60 + Number(aTmp[1]);
  var nDiff = 0;
  if (nStartMin > nEndMin) {
    nDiff = nStartMin - nEndMin;
  } else {
    nDiff = nEndMin - nStartMin;
  }
  var nDiffMin = 0;
  var nDiffHour = 0;
  if (nDiff > 59) {
    nDiffMin = nDiff % 60;
    nDiffHour = (nDiff - nDiffMin) / 60;
  } else {
    nDiffMin = nDiff;
  }
  if (nDiffHour < 10) res += "0";
  res += nDiffHour;
  res += ":";
  if (nDiffMin < 10) res += "0";
  res += nDiffMin;
  return res;
}

function Noleggia() {
  const { modelloVeicolo } = useParams();
  let history = useHistory();

  const { user, setUser } = VerificaToken();

  const [parcheggis, setParcheggi] = useState([]);
  const [ritiro, handleClick] = useState(false);
  const [destinazione, clickDestinazione] = useState(false);
  const [costo, setCosto] = useState(0);
  const [dataInizio, setDataInizio] = useState("");
  const [dataFine, setDataFine] = useState("");
  const [oraInizio, setOraInizio] = useState("");
  const [oraFine, setOraFine] = useState("");
  const [mancia, setMancia] = useState(0);
  const [rilascio, setRilascio] = useState("");
  const [restituzione, setRestituzione] = useState("");
  const [veicoli, setVeicoli] = useState([]);
  const [modello, setModello] = useState("");
  const [tariffa, setTariffa] = useState(0);
  const [vecchiaTariffa, setVecchiaTariffa] = useState(0);
  const [disponibile, setDisponibile] = useState(0);
  const [vecchiaDataInizio, setVecchiaDataInizio] = useState("");
  const [vecchiaDataFine, setVecchiaDataFine] = useState("");
  const [vecchiaOraInizio, setVecchiaOraInizio] = useState("");
  const [vecchiaOraFine, setVecchiaOraFine] = useState("");
  const [listaImpiegati, setListaImpiegati] = useState([]);
  const [idImpiegato, setIdImpiegato] = useState(0);
  const [impiegatoSelezionato, setImpiegatoSelezionato] = useState(false);
  const [tipo, setTipo] = useState("");

  useEffect(() => {
    if (user) {
      if (user.codiceCarta) {
        axios
          .get(
            "https://website-8bit-motors.herokuapp.com/parcheggi/ottieniParcheggi"
          )
          .then((response) => {
            setParcheggi(response.data);
          })
          .catch(() => {
            alert("Connessione Non Disponibile");
          });
        axios
          .get(
            `https://website-8bit-motors.herokuapp.com/veicoli/specifiche/${modelloVeicolo}`
          )
          .then((response) => {
            setVeicoli(response.data);
          })
          .catch(() => {
            alert("Connessione Non Disponibile");
          });
      } else {
        alert("Errore: Nessun metodo di pagamento inserito.");
        history.push(`/account/info/${user.id}/aggiungiPagamento`);
      }
    } else {
      history.push("/account/login");
    }
  }, []);

  let initialValues;

  try {
    initialValues = {
      data_noleggio_iniziale: "",
      orario_noleggio_iniziale: "",
      data_noleggio_finale: "",
      orario_noleggio_finale: "",
      luogo_rilascio_ritiro: "",
      modello: "",
      presenza_autista: "",
      destinazione: "",
      id_impiegato: "",
      id_cliente: user.id,
      numero_carta: user.codiceCarta,
      costo_prenotazione: 0,
    };
  } catch {
    history.push("/");
  }

  const changeValue1 = () => {
    document.getElementById("luogo_rilascio_ritiro").value = "";
    document.getElementById("ritiro_personalizzato").value = "";
    const errorePer = document.getElementById("ritiro_personalizzato");
    const errore = document.getElementById("luogo_rilascio_ritiro");
    if (errore.hasAttribute("required")) {
      errore.attributes.removeNamedItem("required");
      const required = document.createAttribute("required");
      errorePer.attributes.setNamedItem(required);
    } else {
      errorePer.attributes.removeNamedItem("required");
      const required = document.createAttribute("required");
      errore.attributes.setNamedItem(required);
    }
  };

  const changeValue2 = () => {
    document.getElementById("destinazione").value = "";
    document.getElementById("destinazione_personalizzata").value = "";
    const errorePer2 = document.getElementById("destinazione_personalizzata");
    const errore2 = document.getElementById("destinazione");
    if (errore2.hasAttribute("required")) {
      errore2.attributes.removeNamedItem("required");
      const required = document.createAttribute("required");
      errorePer2.attributes.setNamedItem(required);
    } else {
      errorePer2.attributes.removeNamedItem("required");
      const required = document.createAttribute("required");
      errore2.attributes.setNamedItem(required);
    }
  };
  const pagamento = () => {
    let data1 = new Date(dataInizio);
    let data2 = new Date(dataFine);
    if (data1 === "" || data2 === "" || oraInizio === "" || oraFine === "") {
      alert("Devi inserire la data iniziale e la data finale");
      setCosto(0);
    } else {
      if (data1 > data2) {
        alert("Inserire un periodo di noleggio valido");
      } else {
        let differenza = Math.abs(parseInt((data2 - data1) / (1000 * 3600)));
        let differenza2 = GetHourDiff(oraInizio, oraFine);
        let differenza3 = parseInt(differenza2.slice(0, 2));
        let somma;
        if (oraInizio.split(":")[0] > oraFine.split(":")[0]) {
          somma = differenza - differenza3;
        } else {
          somma = differenza + differenza3;
        }

        let prezzo = parseInt(mancia) + tariffa * somma;
        if (prezzo > 0 && impiegatoSelezionato) {
          let randomValue = Math.floor(Math.random() * listaImpiegati.length);
          setIdImpiegato(listaImpiegati[randomValue].id);
          setCosto(prezzo);
        } else {
          alert("Errore: Controlla i campi compilati");
          setCosto(0);
        }
      }

      setVecchiaTariffa(tariffa);
      setVecchiaDataInizio(dataInizio);
      setVecchiaDataFine(dataFine);
      setVecchiaOraInizio(oraInizio);
      setVecchiaOraFine(oraFine);
    }
  };

  const assegnaIncarico = (impiegato) => {
    if (impiegato === "Autista") {
      axios
        .get("https://website-8bit-motors.herokuapp.com/account/ottieniAutisti")
        .then((response) => {
          setListaImpiegati(response.data);
        })
        .catch(() => {
          alert("Connessione Non Disponibile");
        });
    } else {
      if (!user.codicePatente) {
        alert("Per guidare hai bisogno di una patente! Inserire patente o assumere un autista.");
      } else {
        axios
          .get(
            "https://website-8bit-motors.herokuapp.com/account/ottieniAddetti"
          )
          .then((response) => {
            setListaImpiegati(response.data);
          })
          .catch(() => {
            alert("Connessione Non Disponibile");
          });
      }
    }
  };

  const onSubmit = (data) => {
    if (costo === 0) {
      alert("Calcolare il prezzo prima d'inviare");
    } else if (
      tariffa !== vecchiaTariffa ||
      dataInizio !== vecchiaDataInizio ||
      dataFine !== vecchiaDataFine ||
      oraInizio !== vecchiaOraInizio ||
      oraFine !== vecchiaOraFine
    ) {
      alert("Cambiare il prezzo prima di continuare");
    } else if (dataInizio > dataFine) {
      alert("data non valida");
    } else if (tipo !== "Automobile" && data.presenza_autista === "si") {
      alert("Non puoi avere un autista con questo tipo di veicolo!");
    } else {
      const userId = user.id;
      axios
        .post(`https://website-8bit-motors.herokuapp.com/prenotazioni`, {
          data,
          userId,
          dataInizio,
          oraInizio,
          dataFine,
          oraFine,
          modello,
          rilascio,
          restituzione,
          costo,
          idImpiegato,
        })
        .then((response) => {
          const id_prenotazione = response.data.id;
          console.log(id_prenotazione);
          axios
            .post("https://website-8bit-motors.herokuapp.com/incarichi", {
              data,
              dataInizio,
              oraInizio,
              dataFine,
              oraFine,
              modello,
              rilascio,
              restituzione,
              costo,
              idImpiegato,
              id_prenotazione,
            })
            .then(() => {
              const dataVeicolo = {
                modello: modello,
                disponibile: disponibile,
              };
              axios
                .post(
                  `https://website-8bit-motors.herokuapp.com/veicoli/confermaPrenotazione`,
                  dataVeicolo
                )
                .then(() => {
                  history.push("/");
                });
            });
        })
        .catch(() => {
          alert("Connessione Non Disponibile");
        });
    }
  };

  const disponibilità = (quantita) => {
    if (quantita === 0) {
      alert("veicolo non disponibile");
      document.getElementById("modello").value = "";
    }
  };

  if (user) {
    if (user.tipo === "Cliente") {
      return (
        <Container fluid className="text-center">
          {/* SEZIONE BANNER */}
          <Container fluid className="head-banner text-white text-center">
            <Row>
              <Col>
                <h1>
                  <strong>8Bit-Motors</strong>
                </h1>
              </Col>
            </Row>
          </Container>

          <h2 className="mt-2">Noleggia il tuo veicolo</h2>
          <h3>
            Manca poco e potrai godere del veicolo adatto alla tua esigenza!
          </h3>

          <Container>
            <Formik
              initialValues={initialValues}
              onSubmit={onSubmit} /* validationSchema={validationSchema} */
            >
              <Form>
                <Row>
                  <Col>
                    <Bounce left>
                      <label className="mt-2 form_registrazione">
                        Data Noleggio (iniziale):{" "}
                      </label>
                      <ErrorMessage
                        name="data_noleggio_iniziale"
                        component="span"
                      />
                      <Field
                        className="mt-2 form-control input_registrazione"
                        value={dataInizio}
                        as="input"
                        type="date"
                        id="data_noleggio_iniziale"
                        name="data_noleggio_iniziale"
                        placeholder="gg/mm/aaaa"
                        onChange={(event) => {
                          setDataInizio(event.target.value);
                        }}
                        required
                      />

                      <label className="mt-2 form_registrazione">
                        Orario Noleggio (Iniziale):{" "}
                      </label>
                      <ErrorMessage
                        name="orario_noleggio_iniziale"
                        component="span"
                      />
                      <Field
                        className="mt-2 form-control input_registrazione"
                        value={oraInizio}
                        id="orario_noleggio_iniziale"
                        type="time"
                        name="orario_noleggio_iniziale"
                        onChange={(event) => {
                          setOraInizio(event.target.value);
                        }}
                        required
                      />

                      <label className="mt-2 form_registrazione">
                        Data Noleggio (Finale):{" "}
                      </label>
                      <ErrorMessage
                        name="data_noleggio_finale"
                        component="span"
                      />
                      <Field
                        className="mt-2 form-control input_registrazione"
                        value={dataFine}
                        id="data_noleggio_finale"
                        type="date"
                        name="data_noleggio_finale"
                        onChange={(event) => {
                          setDataFine(event.target.value);
                        }}
                        required
                      />

                      <label className="mt-2 form_registrazione">
                        Orario Noleggio (Finale):{" "}
                      </label>
                      <ErrorMessage
                        name="orario_noleggio_finale"
                        component="span"
                      />
                      <Field
                        className="mt-2 form-control input_registrazione"
                        value={oraFine}
                        id="orario_noleggio_finale"
                        type="time"
                        name="orario_noleggio_finale"
                        onChange={(event) => {
                          setOraFine(event.target.value);
                        }}
                      />

                      <Zoom left collapse when={!ritiro}>
                        <label className="mt-2 form_registrazione">
                          Luogo di Ritiro:{" "}
                        </label>
                        <select
                          className=" mt-2 mb-2 form-control input_registrazione"
                          as="select"
                          id="luogo_rilascio_ritiro"
                          name="luogo_rilascio_ritiro"
                          onChange={(event) => {
                            setRilascio(event.target.value);
                          }}
                          required
                        >
                          <option value="" name="luogo_rilascio_ritiro">
                            {" "}
                            ...{" "}
                          </option>
                          {parcheggis.map((value, key) => {
                            return (
                              <option
                                key={key}
                                value={value.luogo}
                                name="luogo_rilascio_ritiro"
                              >
                                {" "}
                                {value.luogo}{" "}
                              </option>
                            );
                          })}
                          ;
                        </select>
                      </Zoom>

                      <Button
                        variant="warning"
                        className="mt-2 mb-2"
                        onClick={() => {
                          handleClick(!ritiro);
                          changeValue1();
                        }}
                      >
                        {" "}
                        {ritiro
                          ? "Scegli Tra i Nostri Parcheggi"
                          : "Imposta Luogo di Ritiro Personalizzato"}{" "}
                      </Button>
                      <Zoom left cascade collapse when={ritiro}>
                        <label className="mb-1 mt-2 form_registrazione">
                          Luogo di Ritiro Personalizzato:{" "}
                        </label>
                        <input
                          className="form-control input_registrazione"
                          id="ritiro_personalizzato"
                          type="text"
                          name="luogo_rilascio_ritiro_personalizzato"
                          placeholder="Es. Via dante..."
                          onChange={(event) => {
                            setRilascio(event.target.value);
                          }}
                        />
                      </Zoom>
                    </Bounce>
                  </Col>

                  <Col>
                    <Bounce right>
                      <label className="mt-2 form_registrazione">
                        Modello scelto:{" "}
                      </label>
                      <select
                        className="mt-2 form-control input_registrazione"
                        id="modello"
                        type="text"
                        name="modello"
                        onChange={(event) => {
                          setModello(JSON.parse(event.target.value).modello);
                          setTariffa(JSON.parse(event.target.value).tariffa);
                          disponibilità(
                            JSON.parse(event.target.value).quantita
                          );
                          setDisponibile(
                            JSON.parse(event.target.value).quantita
                          );
                          setTipo(JSON.parse(event.target.value).Tipo);
                        }}
                        required
                      >
                        {
                          <option value="" name="modello">
                            {" "}
                            Conferma il modello ↓{" "}
                          </option>
                        }
                        {veicoli.map((value, key) => {
                          return (
                            <option
                              key={key}
                              value={JSON.stringify({
                                modello: value.modello,
                                quantita: value.Quantità,
                                tariffa: value.tariffa,
                                Tipo: value.Tipo,
                              })}
                              name="modello"
                            >
                              {" "}
                              {value.Tipo}: {value.modello} -- {value.tariffa}€{" "}
                            </option>
                          );
                        })}
                        ;
                      </select>

                      <label className="mt-2 form_registrazione">
                        <h3>Autista</h3>
                      </label>
                      <Field
                        style={{
                          width: "1.5rem",
                          height: "1.5rem",
                          margin: "0.5rem",
                        }}
                        type="radio"
                        name="presenza_autista"
                        value="si"
                        onClick={() => {
                          assegnaIncarico("Autista");
                          setImpiegatoSelezionato(true);
                        }}
                        required
                      />
                      <br />
                      <label className="mt-2 form_registrazione">
                        <h3>Addetto alla Consegna (PATENTE RICHIESTA):</h3>{" "}
                      </label>
                      <Field
                        style={{
                          width: "1.5rem",
                          height: "1.5rem",
                          margin: "0.5rem",
                        }}
                        type="radio"
                        name="presenza_autista"
                        value="no"
                        onClick={() => {
                          assegnaIncarico("Addetto alla Consegna");
                          setImpiegatoSelezionato(true);
                        }}
                        required
                      />

                      <Zoom left opposite collapse when={!destinazione}>
                        <label className="mt-2 form_registrazione">
                          Destinazione (o luogo di restituzione):{" "}
                        </label>
                        <select
                          className="mt-2 mb-2 form-control input_registrazione"
                          id="destinazione"
                          name="destinazione"
                          onChange={(event) => {
                            setRestituzione(event.target.value);
                          }}
                          required
                        >
                          <option value="" name="destinazione">
                            {" "}
                            ...{" "}
                          </option>
                          {parcheggis.map((value, key) => {
                            return (
                              <option
                                key={key}
                                value={value.luogo}
                                name="destinazione"
                              >
                                {" "}
                                {value.luogo}{" "}
                              </option>
                            );
                          })}
                          ;
                        </select>
                      </Zoom>

                      <Button
                        className="mt-2 mb-2"
                        variant="warning"
                        onClick={() => {
                          clickDestinazione(!destinazione);
                          changeValue2();
                        }}
                      >
                        {destinazione
                          ? "Scegli Tra i Nostri Parcheggi"
                          : "Imposta Una Destinazione Personalizzata"}{" "}
                      </Button>
                      <Zoom left opposite cascade collapse when={destinazione}>
                        <input
                          className="mt-2 form-control input_registrazione"
                          id="destinazione_personalizzata"
                          type="text"
                          name="destinazione"
                          placeholder="Es. Via dante..."
                          onChange={(event) => {
                            setRestituzione(event.target.value);
                          }}
                        />
                      </Zoom>

                      <label className="mt-2 form_registrazione">Mancia:</label>
                      {/* <ErrorMessage name="costo_prenotazione" component="span" /> */}
                      <input
                        className="mt-2 form-control input_registrazione"
                        id="costo_prenotazione"
                        type="number"
                        min="0"
                        name="costo_prenotazione"
                        onChange={(event) => {
                          setMancia(event.target.value);
                        }}
                      />
                    </Bounce>
                  </Col>
                </Row>

                <Button variant="info" className="mt-5" onClick={pagamento}>
                  {" "}
                  Calcola Prezzo{" "}
                </Button>
                <h3 value={costo} required>
                  € {costo}
                </h3>

                <label
                  className="mt-2 form_registrazione"
                  style={{ margin: "0.5rem" }}
                >
                  Dispongo di un dispostivo mobile.
                </label>
                <input
                  type="checkbox"
                  style={{ width: "1rem", height: "1rem" }}
                  required
                />
                <br />

                <Button type="submit" className="mt-4 mb-4" variant="success">
                  {" "}
                  Invia{" "}
                </Button>
              </Form>
            </Formik>
          </Container>
        </Container>
      );
    } else {
      return (
        <Container fluid className="text-center">
          {/* SEZIONE BANNER */}
          <Container fluid className="head-banner text-white text-center">
            <Row>
              <Col>
                <h1>
                  <strong>8Bit-Motors</strong>
                </h1>
              </Col>
            </Row>
          </Container>

          <h3 className="mt-3">
            GLI IMPIEGATI NON POSSONO NOLEGGIARE UN VEICOLO
          </h3>
          <p>
            Torna alla <Link to="/">Home</Link>{" "}
          </p>
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
        </Container>
      );
    }
  } else {
    return <Redirect to="/account/login" />;
  }
}

export default Noleggia;
